import { defineComponent, computed, provide, openBlock, createElementBlock, normalizeProps, renderSlot } from "vue";
import { I as INJECTION_KEY_THEME } from "./constants-wIEKSp2G.mjs";
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "NcThemeProvider",
  props: {
    dark: { type: Boolean },
    light: { type: Boolean }
  },
  setup(__props) {
    const props = __props;
    const theme = computed(() => {
      if (props.dark) {
        return "dark";
      } else if (props.light) {
        return "light";
      }
      return "";
    });
    provide(INJECTION_KEY_THEME, theme);
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", normalizeProps({ [`data-theme-${theme.value}` || ""]: theme.value }), [
        renderSlot(_ctx.$slots, "default")
      ], 16);
    };
  }
});
export {
  _sfc_main as _
};
//# sourceMappingURL=NcThemeProvider.vue_vue_type_script_setup_true_lang-wie70gn4.mjs.map
